import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CrudRoute from './routes/CrudRoute';
import Restricted from './auth/Restricted';
import { URL_WHITELIST } from './config'

const AdminRoutes = ({ customRoutes, resources = [], dashboard }) => (
  <Switch>
    <Route
      exact
      key="dashboard"
      path="/"
      render={routeProps =>
        <Restricted {...routeProps}>
          {React.createElement(dashboard)}
        </Restricted>}
    />
    {
      customRoutes && customRoutes.map((route, index) =>
      URL_WHITELIST.has(route.frontendPath) &&
      <Route
        key={index}
        exact
        path={route.frontendPath}
        component={route.component}
        render={route.render}
        children={route.children}
      />)
    }
    {
      resources.map(resource =>
        URL_WHITELIST.has(resource.frontendPath) &&
        <Route
          path={resource.frontendPath}
          key={resource.name}
          render={() => <CrudRoute
            frontendPath={resource.frontendPath}
            backendPath={resource.backendPath}
            resource={resource.name}
            list={resource.list}
            create={resource.create}
            edit={resource.edit}
            show={resource.show}
            remove={resource.remove}
            options={resource.options}
          />}
        />
      )}


  </Switch>
);

export default AdminRoutes;



// WEBPACK FOOTER //
// ./src/AdminRoutes.js